module.exports = __webpack_public_path__ + "fonts/Pasajero.ttf.b0731ff.woff";